module.exports = __webpack_public_path__ + "static/img/briteappslogonotagline.733e05f.png";